
'use client';

import * as React from 'react';
import { useCurrency, type Currency } from '@/context/CurrencyContext';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Check } from 'lucide-react';

const currencies: { code: Currency; name: string; symbol: string }[] = [
  { code: 'NOK', name: 'Norwegian Krone', symbol: 'kr' },
  { code: 'GBP', name: 'British Pound', symbol: '£' },
  { code: 'EUR', name: 'Euro', symbol: '€' },
  { code: 'USD', name: 'US Dollar', symbol: '$' },
];

export default function CurrencySelector() {
  const { currency, setCurrency } = useCurrency();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className="h-10 px-3 rounded-none hover:bg-white/10 transition-colors tracking-[0.02em]"
          style={{ color: '#daba7b' }}
        >
          {currency}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="w-52 rounded-none border border-[#18191B]/20 bg-[#f5f2ed] p-1 text-[#18191B] shadow-[0_10px_26px_rgba(24,25,27,0.12)]"
      >
        {currencies.map((c) => {
          const isSelected = currency === c.code;
          return (
            <DropdownMenuItem
              key={c.code}
              onClick={() => setCurrency(c.code)}
              className={`cursor-pointer rounded-none px-2.5 py-2 text-sm text-[#18191B] focus:bg-[#18191B]/6 ${
                isSelected ? 'bg-[#d9af3a]' : ''
              }`}
            >
              <span className="w-5 font-semibold">{c.symbol}</span>
              <span className="font-medium">{c.name}</span>
              {isSelected && <Check className="ml-auto h-4 w-4" />}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
